import {
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  EventEmitter,
  ViewChild,
  ComponentFactory, ViewContainerRef, ComponentFactoryResolver, OnDestroy
} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {PedidosService} from "../../services/pedidos.service";
import {MonitoradorPedidos} from "../../fidelidade/MonitoradorPedidos";
import {GroupDescriptor, orderBy, process, SortDescriptor} from "@progress/kendo-data-query";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {ImpressaoService} from "../../services/impressao.service";
import {ComandosImprimirComanda} from "../ComandosImprimirComanda";
import {ComandaService} from "../../services/comanda.service";
import {CellClickEvent, GridComponent} from "@progress/kendo-angular-grid";
import {CadEnderecoContatoComponent} from "../../fidelidade/cad-endereco-contato/cad-endereco-contato.component";

import {GrupolojasService} from "../../superadmin/services/grupolojas.service";
import {ExcelExportData} from "@progress/kendo-angular-excel-export";
import {EntregadorService} from "../../services/entregador.service";
import {DialogCloseResult, DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";
import {PedidoAcoesComponent} from "../../fidelidade/pedido-acoes/pedido-acoes.component";
import { FiscalService } from '../../fidelidade/fiscal/services/fiscal.service';
import { ConfigColunasComponent } from '../config-colunas/config-colunas.component';
import {
  ModalEditarItempedidoMesaComponent
} from "../../fidelidade/modal-editar-mesa/modal-editar-itempedido-mesa.component";
import { ModalDetalhesErroComponent } from '../modal-detalhes-erro/modal-detalhes-erro.component';
import {ModalFeedbackNfceComponent} from '../modal-feedback-nfce/modal-feedback-nfce.component';

const acoes: any = {
  RemoverItem: { text: 'Remover Item', icon: 'fa fa-trash' },
  EditarItem: { text: 'Editar Item', icon: 'fa fa-pen' }
};


@Component({
  selector: 'app-grid-pedidos',
  templateUrl: './grid-pedidos.component.html',
  styleUrls: ['./grid-pedidos.component.scss']
})
export class GridPedidosComponent extends ComandosImprimirComanda implements OnInit,  OnDestroy   {
  @ViewChild('grid', { static: false}) grid: GridComponent;
  @Output() onAtualizouComanda = new EventEmitter();
  @Input() pedidos = [];
  @Input() comanda;
  @Input() mesa = false;
  @Input() editarPedido = true;
  @Input() carregando: any = false;
  @Input() modoGrupoLojas: any = false;
  @Input() modoSimples = false;
  @Input() orderByDesc = false;
  @Input() exibirAcoes = true;
  pedidosOnlineSincronizar: any  = []
  entregadores: any = [];
  ordenacao: SortDescriptor[] = []
  listaPedidos = [];
  agrupar = false;
  public groups: GroupDescriptor[] = [ ];
  public aggregates: any[] = [{ field: 'total', aggregate: 'sum' }, { field: 'id', aggregate: 'count' }];
  groupable: any;
  filtro: any = {};
  categoria: string;

  exibindoMapa = false;
  taxaSelecionada: any;
  public windowTop = 100;
  public windowLeft = 50;
  public altura = 0;

  public pedidosSelecionadosIds: number[]  = [];
  factory: ComponentFactory<PedidoAcoesComponent>;
  imprimindo = false;
  tarefa: any;

  configColunas: any = [
    { field: 'codigo', title: 'Código', visible: true },
    { field: 'horarioVenda', title: 'Realizado', visible: true },
    { field: 'cliente.nome', title: 'Cliente', visible: true },
    { field: 'descricaoFormasPagamento', title: 'Pagamento', visible: true }
  ];

  colunasPagamentos: any = ['taxaEntrega', 'total', 'descricaoFormasPagamento'];
  opcoesItemPedido = [  ]
  itemRemover: any;
  temModuloFiscal  = false;
  temEmissaoNotaFiscalAtiva = false;
  constructor(private router: Router, private activatedRoute: ActivatedRoute, protected pedidosService: PedidosService,
              protected comandaService: ComandaService, public dialogService: DialogService,
              private     grupolojasService: GrupolojasService,
              protected constantsService: ConstantsService, protected impressao: ImpressaoService,
              public monitoradorPedidos: MonitoradorPedidos,
              private entregadorService: EntregadorService,
              private viewContainerRef: ViewContainerRef, private resolver: ComponentFactoryResolver,
              private fiscalService: FiscalService) {
    super(pedidosService, constantsService, impressao);

    this.activatedRoute.queryParams.subscribe(queryParams => {
      if( this.mesa ) {
        this.groupable = { showFooter: true };
      } else {
        this.groupable = true;
      }
    });
    this.entregadorService.liste().then((entregadores: any) => {
      this.entregadores = entregadores
    })

    this.constantsService.moduloFiscal$.subscribe( data => {
      this.temModuloFiscal = data
    });

    this.constantsService.emissaoNotaFiscalAtiva$.subscribe((ativa) => {
      this.temEmissaoNotaFiscalAtiva = !!ativa;
    });

    this.factory = this.resolver.resolveComponentFactory(PedidoAcoesComponent);
  }

 async imprimirVarios(impressora: any = null, layoutPedido: string  = null){
    let pedidos = this.listaPedidos.filter((item: any) =>    this.pedidosSelecionadosIds.indexOf(item.id) >= 0 );

    this.imprimindo = true;

    try {
      const impressoraSelecionada = impressora ? {...impressora} : this.obtenhaImpressoraPadrao();

      if(!impressoraSelecionada) {
        this.impressao.onErrosImpressao.emit('Nenhuma impressora configurada');
        return;
      }

      const layout = this.obtenhaLayoutPadrao(impressoraSelecionada, layoutPedido);

      if(layout)
        impressoraSelecionada.layout = layout;

      await this.impressao.imprimaEmLote(pedidos, impressoraSelecionada)

      this.pedidosSelecionadosIds = []
    } finally {
      this.imprimindo = false;
    }

  }

  evitarSelecao(event: any){
    event.stopPropagation();
    return false;
  }

  ngOnInit() {
    super.ngOnInit();
    this.atualizeGridPedidos();
    setTimeout(() => {
      this.carregueColunasVisiveis();
      if(this.mesa)
        this.expandAllRows();
    })


    this.constantsService.empresa$.subscribe((empresa: any) => {
      if(empresa){
        if(!empresa.integracaoDelivery){
          this.opcoesItemPedido.splice(0, 0, acoes.EditarItem)
          this.opcoesItemPedido.splice(0, 0, acoes.RemoverItem)
        }
      }
    })

  }

  expandAllRows() {
    if (this.grid && this.listaPedidos?.length) {
      this.listaPedidos.forEach((_, idx) => {
        this.grid.expandRow(idx);
      });
    }
  }

  prevenirSelecao(evt: MouseEvent): boolean {
    evt.stopPropagation();
    evt.preventDefault();
    return false;
  }


  carregueColunasVisiveis(){
    let configLocal = localStorage.getItem(this.obtenhaChaveConfig() )

    if(configLocal){
      try{
        this.configColunas = JSON.parse(configLocal)
      } catch (er){
        console.error(er)
        this.setColunasVisiveis();
      }
    } else {
      this.setColunasVisiveis();
    }
  }


  atualizeGridPedidos(pedidos =  [], categoria = '', ordernar: boolean = null) {
    this.categoria = categoria;
    this.listaPedidos = this.mesa ? pedidos.filter((item: any) => item.mesa) : pedidos;

    if(ordernar)  this.ordenacaoPadrao();

    if( this.mesa ) {

      let group: any = {field: 'comanda.id', aggregates: this.aggregates};
      if(this.orderByDesc)  group.dir = 'desc'

      this.groups = [group];
    } else {
      this.agrupar = this.listaPedidos.find( (pedido) => pedido.aguardandoPagamentoOnline) != null;
      this.groups = this.agrupar ?   [{ field: 'grupo', dir: 'desc' }] : [];
    }

    this.listaPedidos.forEach( (pedido: any) => {
      pedido.grupo =   pedido.aguardandoPagamentoOnline ? 'Aguardando Confirmação de Pagto. Online' : 'Pedidos Recebibos';
    });

    this.setOnlineSincronizar();
  }

  setColunasConfigExibir(){
    if(this.exibirColunaEntregador()){
      this.configColunas.push({ title: 'Entregador', visible: true})
    } else {
      this.configColunas.push( { field: 'taxaEntrega', title: 'Taxa Entrega', visible: true });
      this.configColunas.push( { field: 'total', title: 'Total', visible: true });
    }

    this.configColunas.push(  { field: 'pago', title: 'Pago', visible: true })
  }

  setColunasVisiveis(){

    this.configColunas = []

    this.grid.columns.forEach((item: any) => {
      if(this.exibirColunaEntregador() && this.colunasPagamentos.indexOf(item.field) >= 0) return;

      if(item.field === 'comanda.id') { // de mesa
        console.log(item);
        return
      }

      if(item._width && item.title && !item.headerTemplates.length)
        this.configColunas.push({ field: item.field, title: item.title, visible: !item.hidden })
    })
  }



  setOnlineSincronizar(){
    this.pedidosOnlineSincronizar = this.listaPedidos.filter((item: any) => item.aguardandoPagamentoOnline)

    if(this.pedidosOnlineSincronizar.length && ! this.tarefa)
      this.tarefa =   setInterval(() => this.verifiqueOnlinePendentes(), 20 * 1000);


  }

  obtenhaDescricaoPagamentoPedido(pedido: any): string {
    if(pedido?.fiado === true && !pedido?.pagamentoOnline && !pedido?.descricaoFormasPagamento)
      return 'Pagar depois';

    return pedido?.descricaoFormasPagamento || '';
  }

  verifiqueOnlinePendentes(){

    for(let i = 0 ; i < this.pedidosOnlineSincronizar.length; i++){
      let pedido: any = this.pedidosOnlineSincronizar[i];
      const horasAguardando = pedido.duracao  / 60;
      if( horasAguardando < 8 &&  !pedido.sincronizandoPagamento ){ // menos 8hs foi realizado, ficar sincronizando
        pedido.sincronizandoPagamento = true;
        this.pedidosService.sincronizePagamentoOnline(pedido).then((resposta: any) => {
          pedido.sincronizandoPagamento = false;
          if(resposta && resposta.id)
            Object.assign(pedido, resposta);
        }).catch((err) => {
          pedido.sincronizandoPagamento = false;
        });
      }
    }
  }

  verFechamento(grupo){
    const comanda = grupo.items[0].comanda;

    if(!comanda.fechada)   this.vaParaFecharMesa(comanda)

    return false;
  }

  verPedidoNaLoja(pedido: any){
   window.open(String(`https://${pedido.empresa.dominio}.promokit.com.br/admin/pedidos/detalhes/${pedido.guid}`))
  }

  abriuPedido(event: any) {
    let pedido: any = event.dataItem;


    if(!pedido.carregouItens){
      pedido.carregando = true;
      this.getService().obtenhaPorCodigo(pedido.guid, pedido.empresa.id).then(( pedidoCompleto: any) => {
        pedido.carregando = false;
        pedido.itens = pedidoCompleto.itens;
        pedido.adicionaisImprimir = pedidoCompleto.adicionaisImprimir;
        pedido.carregouItens = true;
      });
    }

    if (pedido)
      this.getService().foiVisualizado(pedido, pedido.empresa.id).then(() => {
        pedido.visualizado = true;
        this.monitoradorPedidos.atualizeFoiLido(pedido)

      })
  }

  fecharMesa(grupo: any) {
    const comanda = grupo.items[0].comanda;

    if( !comanda ) { return; }

    this.vaParaFecharMesa(comanda)

  }

  vaParaFecharMesa(comanda){
    /* Removed unsupported properties by Angular migration: queryParams. */
    this.router.navigateByUrl(`/admin/fechar-mesa/${comanda.id}?t=` + new Date().getTime(), {}).then( () => {})
  }

  obtenhaComanda(grupo: any) {
    return grupo.items[0].comanda;
  }

  verErroIntegracao(pedido: any, event = null) {
    // Abrir modal com detalhes do erro usando o componente personalizado
    const dialogRef: DialogRef = this.dialogService.open({
      title: 'Detalhes do Erro de Integração',
      content: ModalDetalhesErroComponent,
      width: 600,
      height: 500
    });

    // Configurar dados do modal
    const modalInstance = dialogRef.content.instance;
    modalInstance.titulo = 'Detalhes do Erro de Integração';
    modalInstance.sistema = this.empresa.integracaoDelivery?.sistema || 'N/A';
    modalInstance.pedido = pedido.codigo;
    modalInstance.erro = pedido.erroExterno;
    modalInstance.dataHora = new Date().toLocaleString('pt-BR');

    if(event){
      event.stopPropagation();
      event.preventDefault();
    }
  }

  reenviarPedido(pedido: any, event) {
    event.stopPropagation();
    event.preventDefault();

    if (pedido.reenviando) return;

    pedido.reenviando = true;

    this.getService().notifiqueSistemaIntegrado(pedido, this.empresa.id).then( (resp) => {
      pedido.referenciaExterna = resp;
      pedido.naoNotificado = false;
      pedido.reenviando = false;
    }).catch( erro => {
      pedido.reenviando = false;
      pedido.erroExterno = erro;
      this.verErroIntegracao(pedido, null)
    })
  }

  clicouNaCelula($event: CellClickEvent) {
    if($event.columnIndex  < 2 ) return;

    if( $event.dataItem.expandido ) {
      $event.sender.collapseRow($event.rowIndex);
      $event.dataItem.expandido = false;
    } else {
      $event.sender.expandRow($event.rowIndex)
      $event.dataItem.expandido = true;
      this.abriuPedido($event)
    }

    return false;
  }

  abraModalEditarEndereco(event: any, pedido: any) {

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: CadEnderecoContatoComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)


    windowRef.content.instance.setEndereco(pedido.endereco, true);

    windowRef.result.subscribe((result: any) => {
      if(result && result.id) {
        pedido.endereco = Object.assign(pedido.endereco, result);
        pedido.enderecoCompleto = result.enderecoCompleto;
      }
    } );

    event.stopPropagation();
    event.preventDefault();
  }

  getService(): any {
    if (this.modoGrupoLojas)
      return this.grupolojasService;

    return this.pedidosService;
  }

  public exportToExcel(grid: GridComponent): void {
    let colunasOcultas = ['transacao.codigo', 'cashbackUsado', 'cliente.telefone'];

    if(this.exibirColunaEntregador())
      colunasOcultas.push(...this.colunasPagamentos)


    colunasOcultas.forEach((nomeColuna) => {
      let coluna = grid.columns.find((item: any) => item.field === nomeColuna );

      coluna.hidden = false;
    })

    grid.saveAsExcel();

    colunasOcultas.forEach((nomeColuna) => {
      let coluna = grid.columns.find((item: any) => item.field === nomeColuna );

      coluna.hidden = true;
    })
  }

  public pedidosExportar = (): any  => {
    let myState: any = {};

    myState.skip = 0;
    myState.take = this.pedidos.length;

    const result: ExcelExportData =  {
      data: process(this.pedidos, myState).data
    };
    return result;
  };

  expandirDetalhes(){
    return !this.modoSimples
  };

  obtenhaNomeArquivoDownload(nome: string) {
    let sufixo =  this.categoria,
      horario = new Date().getTime();

    if(this.mesa){
       sufixo += '-mesa'
    } else {
      sufixo += '-delivery'
    }


   // sufixo = String(`${inicio}_e_${fim}`)

    return String(`${nome}-${sufixo}.xls`)
  }

  exibaMapa(event, pedido) {
    event.preventDefault();

    let taxa = {
      fazEntrega: true,
      erro: '',
      localizacao: pedido.endereco.localizacao,
      valor: pedido.taxaEntrega
    };

    this.exibindoMapa = true;
    if( taxa.fazEntrega ) {
      this.taxaSelecionada = {
        localizacao: taxa.localizacao,
        msg: "Dentro da área de entrega: " + new Intl.NumberFormat('pt-BR',
          {style: 'currency', currency: 'BRL'}).format(taxa.valor)
      };
    } else {
      this.taxaSelecionada = {
        localizacao: taxa.localizacao,
        msg: taxa.erro
      };
    }

    return false;
  }

  fecharTelaMapa() {
    this.exibindoMapa = false;
  }

  reabraComanda(comanda: any){
    comanda.atualizando = true;
    this.comandaService.reabraComanda(comanda).then(() => {
        comanda.atualizando = false;
        comanda.abertura = true;
        comanda.fechada = false;
        this.vaParaFecharMesa(comanda)
    }).catch((erro) => {
      comanda.atualizando = false;
      alert(erro)
    })
  }

  exibirColunaEntregador() {
    if(!this.empresa || this.mesa) return false;

    if(this.empresa.integracaoUberdirect && this.empresa.integracaoUberdirect.ativa) return true;

    if(this.empresa.integracaoFoodyDelivery && this.empresa.integracaoFoodyDelivery.ativa) return true;

    if(this.temIntegracaoIfoodDelivery()) return true;

    return this.empresa.integracaoOpendeliveryLogistica && this.empresa.integracaoOpendeliveryLogistica.ativa
  }

  temIntegracaoIfoodDelivery(){
    return this.empresa.integracoesIfood && this.empresa.integracoesIfood.find((item: any) => item.shippingApi) != null;
  }

  obtenhaLinkContato(pedido: any){
    if(pedido.cliente.telefone) return String(`/admin/contatos/${pedido.cliente.codigoPais}${pedido.cliente.telefone}`)

    return String(`/admin/contatos/id/${pedido.cliente.id}`)
  }

  podeEmitirNfce(pedido: any): boolean {
    if(!this.temModuloFiscal) return false;
    if(!this.temEmissaoNotaFiscalAtiva) return false;
    if(this.mesa) return false; //no caso de mesa, deve ser emitida pela comanda e não pela mesa
    // Verificar se o pedido está pago e não tem NFC-e emitida
    return pedido.pago && !pedido.notaFiscalEmitida;
  }

  podeEmitirNfceDaComanda(comanda: any): boolean {
    if(!this.temModuloFiscal)  {
      return false;
    }

    if(!this.temEmissaoNotaFiscalAtiva) {
      return false;
    }

    let podeEmitir = comanda.fechada && !comanda.notaFiscalEmitida;
    return podeEmitir;
  }

  onSortChange(sort: SortDescriptor[]): void {
    this.listaPedidos = orderBy(this.listaPedidos, sort);

    const campo: SortDescriptor = sort[0];

    if(campo.field === 'codigo' && campo.dir){
      localStorage.setItem('ordenarPorCodigo', campo.dir)
    } else {
      localStorage.removeItem('ordenarPorCodigo');
      this.ordernePorPrevisaoFicarPronto();
    }
  }

  ordernePorCodigo(direcao: any = 'asc'){
    this.ordenacao = [{ field: 'codigo', dir: direcao }];
    //this.listaPedidos = orderBy(this.listaPedidos,  this.ordenacao);
  }

  ordenacaoPadrao(){
    let salvoPorCodigo = localStorage.getItem('ordenarPorCodigo')

    if(salvoPorCodigo){
      this.ordernePorCodigo(salvoPorCodigo);
    } else {
      this.ordernePorPrevisaoFicarPronto();
    }
  }

  ordernePorPrevisaoFicarPronto(){

    this.listaPedidos.sort((a, b) => {
      const dataA = new Date(a.horarioPrevisoFicarPronto);
      const dataB = new Date(b.horarioPrevisoFicarPronto);

      // Ordem decrescente (do mais recente para o mais antigo)
      return dataA.getTime() - dataB.getTime()
    });
  }

  ngOnDestroy(): void {
    if(this.tarefa) clearInterval(this.tarefa)
  }

  abrirConfigColunas() {

    const dialogRef: DialogRef = this.dialogService.open({
      title: '',
      content: ConfigColunasComponent,
      width: 400,
      height: 500
    });

    dialogRef.content.instance.colunas  = [...this.configColunas]


    dialogRef.result.subscribe((result) => {
      if (result && !(result instanceof DialogCloseResult)) {
        this.configColunas = result;
        // Salvar configuração no localStorage
        localStorage.setItem(this.obtenhaChaveConfig(), JSON.stringify(result));
      }
    });
  }

  isColumnVisible(field: string, title: string = null): boolean {
    const coluna = this.configColunas.find(c => field ?  (c.field === field) : (c.title === title));
    return coluna ? coluna.visible : true;
  }

  obtenhaChaveConfig(){
    let chave =  `gridPedidosConfig${this.empresa.id}`;

    if(this.mesa) chave = `${chave}mesa`

    return  chave
  }

  escolheuOpcaoItemPedido(opcao: any, item: any) {
    if(opcao === acoes.RemoverItem){
      this.itemRemover  = item;
    } if(opcao === acoes.EditarItem){
      this.abraModalEditarItemPedido(item);
    } else if(opcao === acoes.EditarPedido) {
      this.vaParaEditarPedido(item.pedido)
    }
  }


  removaItemPedidoComanda(){
    if(  this.itemRemover.removendo ) return;

    this.itemRemover.erro  = null
    this.itemRemover.removendo = true

    let dados = Object.assign({} ,  this.itemRemover)
    dados.qtde = 0;
    delete dados.pedido;

    this.comandaService.altereItemPedido( this.comanda, this.itemRemover.pedido,  dados).then(() => {
      delete this.itemRemover;
      this.onAtualizouComanda.emit(this.comanda)
    }).catch((err) => {
      this.itemRemover.removendo = false ;
      this.itemRemover.erro = err.message || err;
    })
  }

  canceleRemover(){
    if(this.itemRemover.removendo) return;
    delete this.itemRemover;
  }


  abraModalEditarItemPedido(item: any){
    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalEditarItempedidoMesaComponent,
      minWidth: 400,
      width: window.innerWidth > 650 ? 650 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    windowRef.content.instance.item = item;
    windowRef.content.instance.comanda = this.comanda;
    windowRef.result.subscribe( (result: any) => {
      if(result && result.recarregar)
        this.onAtualizouComanda.emit(this.comanda)
    } );

  }

  vaParaEditarPedido(pedido: any) {
    this.router.navigateByUrl('/admin/pedidos/' + pedido.guid).then( () => {});
  }

  private abraDialogMensagem(feedback: any): void {
    const largura = window.innerWidth > 640 ? 520 : (window.innerWidth - 32);
    const dialogRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalFeedbackNfceComponent,
      width: largura < 300 ? 300 : largura,
      minWidth: 300,
      maxWidth: 520,
      cssClass: 'bsModal'
    });

    const modalInstance = dialogRef.content.instance as ModalFeedbackNfceComponent;
    modalInstance.titulo = feedback?.titulo || '';
    modalInstance.subtitulo = feedback?.subtitulo || '';
    modalInstance.mensagem = feedback?.mensagem || '';
    modalInstance.produto = feedback?.produto || '';
    modalInstance.listaPendencias = Array.isArray(feedback?.listaPendencias) ? feedback.listaPendencias : [];
    modalInstance.tipo = feedback?.tipo || 'erro';
  }

  private exibaDialogSucessoEmissaoNfce(): void {
    this.abraDialogMensagem({
      titulo: 'NFC-e emitida com sucesso',
      subtitulo: 'A nota foi emitida e vinculada ao pedido.',
      tipo: 'sucesso',
      listaPendencias: []
    });
  }

  private exibaDialogErroEmissaoNfce(erro: any): void {
    this.abraDialogMensagem(this.obtenhaFeedbackErroEmissaoNfce(erro));
  }

  private obtenhaFeedbackErroEmissaoNfce(erro: any): any {
    const erroNormalizado = erro?.error?.erro || erro?.error || erro;

    if (erroNormalizado?.tipo === 'validacao_fiscal_nfce') {
      return {
        titulo: erroNormalizado.titulo || 'Não foi possivel emitir a NFC-e',
        subtitulo: erroNormalizado.subtitulo || 'Revise as pendencias abaixo para tentar novamente.',
        mensagem: erroNormalizado.mensagem || '',
        produto: erroNormalizado.produto || '',
        listaPendencias: Array.isArray(erroNormalizado.detalhes) ? erroNormalizado.detalhes : [],
        tipo: 'erro'
      };
    }

    const mensagem = this.obtenhaMensagemErroEmissaoNfce(erroNormalizado);
    return {
      titulo: 'Nao foi possivel emitir a NFC-e',
      subtitulo: 'Revise a mensagem abaixo para tentar novamente.',
      mensagem,
      produto: '',
      listaPendencias: [{
        tipo: 'erro',
        titulo: 'Emissao interrompida',
        descricao: mensagem
      }],
      tipo: 'erro'
    };
  }

  private obtenhaMensagemErroEmissaoNfce(erro: any): string {
    if (!erro) {
      return 'Erro ao emitir NFC-e. Tente novamente.';
    }

    if (typeof erro === 'string') {
      return erro;
    }

    if (typeof erro?.erro === 'string') {
      return erro.erro;
    }

    if (typeof erro?.message === 'string') {
      return erro.message;
    }

    if (typeof erro?.error?.erro === 'string') {
      return erro.error.erro;
    }

    if (typeof erro?.error?.message === 'string') {
      return erro.error.message;
    }

    if (typeof erro?.error === 'string') {
      return erro.error;
    }

    return 'Erro ao emitir NFC-e. Tente novamente.';
  }

  emitirNfce(pedido: any, event?: any): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    pedido.emitindoNfce = true;

    this.fiscalService.emitaNfcePedido(pedido.id)
      .then(response => {
        console.log('Resposta nfc-e', response)
        pedido.emitindoNfce = false;
        if (response && response.nfce) {
          pedido.notaFiscalEmitida = true;
          pedido.notaFiscal = response.nfce;
          this.exibaDialogSucessoEmissaoNfce();
        } else {
          this.exibaDialogErroEmissaoNfce(response);
        }
      })
      .catch(error => {
        console.error('Erro ao emitir NFC-e:', error);
        pedido.emitindoNfce = false;
        this.exibaDialogErroEmissaoNfce(error);
      });
  }

  emitirNfceDaComanda(comanda: any, event?: any): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    comanda.atualizando = true;

    this.fiscalService.emitaNfceComanda(comanda.id)
      .then(response => {
        console.log('Resposta nfc-e', response)
        comanda.atualizando = false;
        if (response && response.nfce) {
          comanda.notaFiscalEmitida = true;
          comanda.notaFiscal = response.nfce;
          this.exibaDialogSucessoEmissaoNfce();
        } else {
          this.exibaDialogErroEmissaoNfce(response);
        }
      })
      .catch(error => {
        console.error('Erro ao emitir NFC-e:', error);
        comanda.atualizando = false;
        this.exibaDialogErroEmissaoNfce(error);
      });
  }


  // Método para formatar a chave de acesso
  formatChaveAcesso(chave: string): string {
    if (!chave) return '';
    return chave.match(/.{1,4}/g)?.join(' ') || chave;
  }

  // Método para truncar texto longo
  truncarTexto(texto: string, maxLength: number = 80): string {
    if (!texto) return '';
    if (texto.length <= maxLength) return texto;
    return texto.substring(0, maxLength) + '...';
  }

  // Método para obter classe CSS baseada no tipo de erro
  getClasseErro(pedido: any): string {
    if (pedido.naoNotificado) return 'erro-integracao';
    if (pedido.motivoReprovacao) return 'erro-pagamento';
    return '';
  }

  obtenhaFinal(codigo: any) {
    return codigo ? codigo.toString().slice(-4) : ''
  }
}
